import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CASE_STUDIES_FULL } from "../../data/caseStudies";

/** Scrolling strip of the biggest documented wins, each linking to its case study. */
const WINS = CASE_STUDIES_FULL.filter((c) => /^\+\d+%$/.test(c.metric))
  .sort((a, b) => parseInt(b.metric, 10) - parseInt(a.metric, 10))
  .slice(0, 14);

export default function ResultsTicker() {
  return (
    <div className="bg-charcoal text-white border-y border-white/10 flex items-stretch" data-testid="results-ticker" aria-label="Recent client results">
      <div className="flex-none hidden sm:flex items-center gap-2 px-5 bg-electric">
        <span className="w-1.5 h-1.5 bg-white rounded-full animate-blink" />
        <span className="text-[10px] font-black uppercase tracking-[0.2em] whitespace-nowrap">Documented wins</span>
      </div>
      <Marquee gradient={false} speed={38} pauseOnHover className="flex-1 min-w-0">
        {WINS.map((c) => (
          <Link
            key={c.slug}
            to={`/case-studies/${c.slug}`}
            className="group flex items-center gap-2.5 px-6 py-3 border-r border-white/10 text-sm whitespace-nowrap hover:bg-white/5 transition-colors"
          >
            <span className="font-display text-lg font-black text-electric leading-none">{c.metric}</span>
            <span className="text-zinc-200">{c.metricLabel}</span>
            <span className="text-zinc-500">· {c.appName} · {c.category}</span>
            <ArrowUpRight className="w-3.5 h-3.5 text-zinc-600 group-hover:text-electric" />
          </Link>
        ))}
      </Marquee>
    </div>
  );
}
